import { ActionKeys } from '~/actions/constants';
import Invoice from '~/types/Invoice';

const DEFAULT_PAGE = 1;
const DEFAULT_COUNT = 10;

export function chargeInvoice(objectId: string) {
  return <const>{
    type: ActionKeys.INVOICE_CHARGE,
    payload: { objectId },
  };
}

export function chargeInvoiceSuccess(invoice: Invoice) {
  return <const>{
    type: ActionKeys.INVOICE_CHARGE_SUCCESS,
    payload: { invoice },
  };
}

export function chargeInvoiceError(objectId: string, err: Error) {
  return <const>{
    type: ActionKeys.INVOICE_CHARGE_ERROR,
    payload: { objectId, err },
  };
}

export function fetchInvoice(invoiceId: string) {
  return <const>{
    type: ActionKeys.INVOICE_FETCH,
    payload: { invoiceId },
  };
}

export function fetchInvoiceSuccess(invoice: Invoice) {
  return <const>{
    type: ActionKeys.INVOICE_FETCH_SUCCESS,
    payload: { invoice },
  };
}

export function fetchInvoiceError(err: Error) {
  return <const>{
    type: ActionKeys.INVOICE_FETCH_ERROR,
    payload: { err },
  };
}

export function fetchInvoices(page: number = DEFAULT_PAGE, count: number = DEFAULT_COUNT) {
  return <const>{
    type: ActionKeys.INVOICES_FETCH,
    payload: { page, count },
  };
}

export function fetchInvoicesSuccess(invoices: Invoice[], page: number, numPages: number) {
  return <const>{
    type: ActionKeys.INVOICES_FETCH_SUCCESS,
    payload: { invoices, page, numPages },
  };
}

export function fetchInvoicesError(err: Error) {
  return <const>{
    type: ActionKeys.INVOICES_FETCH_ERROR,
    payload: { err },
  };
}

export type InvoicesActions =
  | ReturnType<typeof chargeInvoice>
  | ReturnType<typeof chargeInvoiceSuccess>
  | ReturnType<typeof chargeInvoiceError>
  | ReturnType<typeof fetchInvoice>
  | ReturnType<typeof fetchInvoiceSuccess>
  | ReturnType<typeof fetchInvoiceError>
  | ReturnType<typeof fetchInvoices>
  | ReturnType<typeof fetchInvoicesSuccess>
  | ReturnType<typeof fetchInvoicesError>;
